import { useCarrier } from '../../../../services/CarriersProvider'
import { Spinner } from '@nike/eds'

export const TooltipCarrierContent = ({ vendorCode, hubCode }) => {
  const [carrier, loading, error] = useCarrier(vendorCode, hubCode)
  if (loading) {
    return <Spinner size={'medium'}></Spinner>
  } else if (carrier) {
    return (
      <table className="tooltip-shipto-content">
        <thead>
          <th colSpan={2}>
            <td style={{ color: 'white' }}>Carrier Details</td>
          </th>
        </thead>
        <tbody>
          {carrier?.carrierCode && (
            <tr>
              <td style={{ color: 'white' }}>Carrier Code:</td>
              <td style={{ color: 'white' }}>{carrier.carrierCode}</td>
            </tr>
          )}
          {carrier?.carrierName && (
            <tr>
              <td style={{ color: 'white' }}>Carrier Name:</td>
              <td style={{ color: 'white' }}>{carrier.carrierName}</td>
            </tr>
          )}
        </tbody>
      </table>
    )
  } else {
    return <span>{error ? 'Error' : 'Not found'}</span>
  }
}

export default TooltipCarrierContent
